const TABLE_ACTION_BASE =
  "inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors";

export const tableActionClass = `${TABLE_ACTION_BASE} bg-primary/[0.05] text-primary ring-1 ring-primary/[0.08] hover:bg-primary hover:text-white`;

export const tableActionPrimaryClass = `${TABLE_ACTION_BASE} bg-collect px-2.5 py-1.5 font-semibold text-white shadow-sm hover:bg-collect/90`;

export const tableActionInfoClass = `${TABLE_ACTION_BASE} bg-sky-50 px-2.5 py-1.5 text-sky-700 ring-1 ring-sky-600/10 hover:bg-sky-100`;

export const tableActionMutedClass = `${TABLE_ACTION_BASE} bg-primary/[0.04] px-2.5 py-1.5 text-primary/70 ring-1 ring-primary/[0.06] hover:bg-primary/[0.08] hover:text-primary`;

export const tableActionCompactClass = `${TABLE_ACTION_BASE} bg-primary/[0.06] px-2 py-1 text-[10px] font-bold text-primary/70 ring-1 ring-primary/[0.06] hover:bg-primary hover:text-white`;
